export default __webpack_public_path__ + "static/media/title-winners_vi.8e415d9a.png";